<template>
  <div>
    <a-card title="房间">
      <a slot="extra" v-if="isDelete" @click="deleteItem">删除</a>
      <a-form-model
        ref="ruleForm"
        :rules="formRules"
        :model="formData"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        class="form"
      >
        <a-row :gutter="24">
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="房号" prop="roomNum">
              <a-select
                allowClear
                showSearch
                v-model="formData.roomNum"
                placeholder="请选择房号"
              >
                <a-select-option
                  v-for="item in fangNum"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="朝向" prop="roomDirection">
              <a-select
                allowClear
                showSearch
                v-model="formData.roomDirection"
                placeholder="请选择朝向"
              >
                <a-select-option
                  v-for="item in roomDirectionList"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="付款方式" prop="payWay">
              <a-select
                allowClear
                showSearch
                v-model="formData.payWay"
                placeholder="请选择付款方式"
              >
                <a-select-option
                  v-for="item in baseInfo.payWayList"
                  :key="item.dictCode"
                  :value="item.dictCode"
                  >{{ item.dictName }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="租金(元/月)" prop="rent"
              ><a-input
                type="number"
                suffix="￥"
                v-model="formData.rent"
                placeholder="请输入租金"
              ></a-input
            ></a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="面积" prop="roomArea"
              ><a-input
                type="number"
                suffix="㎡"
                v-model="formData.roomArea"
                placeholder="请输入面积"
              ></a-input
            ></a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="最短租期(月)" prop="shortLease">
              <a-input
                suffix="月"
                type="number"
                v-model="formData.shortLease"
                placeholder="请输入最短租期"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="限住人数" prop="limitNum">
              <a-input
                suffix="人"
                v-model="formData.limitNum"
                placeholder="请输入限住人数"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="租期" prop="isShortRent">
              <a-select
                allowClear
                showSearch
                v-model="formData.isShortRent"
                placeholder="请选择租期"
              >
                <a-select-option
                  v-for="item in shortRentList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="水费(元)" prop="waterCost">
              <a-input
                suffix="￥"
                v-model="formData.waterCost"
                placeholder="请输入水费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="电费(元)" prop="electricityCost">
              <a-input
                suffix="￥"
                v-model="formData.electricityCost"
                placeholder="请输入电费"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="天然气费(元)" prop="naturalGasCost">
              <a-input
                suffix="￥"
                v-model="formData.naturalGasCost"
                placeholder="请输入天然气费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="暖气费(元)" prop="heatingCost">
              <a-input
                suffix="￥"
                v-model="formData.heatingCost"
                placeholder="请输入暖气费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="物业费(元/月)" prop="propertyFee">
              <a-input
                suffix="￥"
                v-model="formData.propertyFee"
                placeholder="请输入物业费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="网费(元/月)" prop="internetFee">
              <a-input
                suffix="￥"
                v-model="formData.internetFee"
                placeholder="请输入网费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="服务费(元/月)" prop="serviceFee">
              <a-input
                suffix="￥"
                v-model="formData.serviceFee"
                placeholder="请输入服务费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item label="配件信息">
              <a-checkable-tag
                v-for="item in baseInfo.roomPartList"
                @change="checked => partHandleChange(item.dictCode, checked)"
                :checked="
                  tempPartList.indexOf(item.dictCode) > -1 ? true : false
                "
                :key="item.dictCode"
              >
                {{ item.dictName }}
              </a-checkable-tag>
              <!-- <a-checkable-tag
                v-for="item in roomParts"
                @change="partHandleChange(item)"
                v-model="item.check"
                :key="item.id"
                >{{ item.dictName }}</a-checkable-tag
              > -->
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item label="图片" prop="fileList">
              <a-upload
                accept="image/*"
                listType="picture-card"
                :multiple="true"
                :fileList="formData.fileList"
                :beforeUpload="beforeUpload"
                :remove="handleRemove"
              >
                <div v-if="formData.fileList.length < 10">
                  <a-icon type="inbox" :style="{ fontSize: '30px' }" />
                  <div class="ant-upload-text">选择图片上传</div>
                </div>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import crypto from "../../../../utils/oss/crypto.js";
import hmac from "../../../../utils/oss/hmac.js";
import base64 from "../../../../utils/oss/base64.js";
import request from "../../../../utils/request.js";
import ImageCompressor from "image-compressor.js";
import cloneDeep from "lodash.clonedeep";
export default {
  name: "RoomItem",
  props: {
    refKey: {
      type: String,
      default: "form"
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    oss: {
      type: Object,
      default: function() {
        return {};
      }
    },
    baseInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      roomParts: [], //配件信息
      formData: {
        roomNum: undefined, //房号
        roomDirection: undefined, //朝向
        rent: 0, //租金
        payWay: undefined, //付款方式
        shortLease: "", //最短租期
        limitNum: "1", //限住人数
        isShortRent: undefined, //租期
        waterCost: 0, //水费
        roomArea: 0, //面积
        electricityCost: 0, //电费
        naturalGasCost: 0, //天然气费
        heatingCost: 0, //暖气费
        propertyFee: 0, //物业费
        internetFee: 0, //网费
        serviceFee: 0, //服务费
        roomParts: "", //配件信息
        smallImage: "", //缩略图
        houseName: "", //房源名称
        fileList: [] //图片
      },
      formRules: {
        roomNum: [{ required: true, message: "请选择房号" }],
        roomDirection: [{ required: true, message: "请选择朝向" }],
        payWay: [{ required: true, message: "请选择付款方式" }],
        rent: [{ required: true, message: "请输入租金" }],
        roomArea: [{ required: true, message: "请输入面积" }],
        shortLease: [{ required: true, message: "请输入最短租期" }],
        limitNum: [{ required: true, message: "请输入限住人数" }],
        isShortRent: [{ required: true, message: "请选择租期" }],
        waterCost: [{ required: true, message: "请输入水费" }],
        electricityCost: [{ required: true, message: "请输入电费" }],
        naturalGasCost: [{ required: true, message: "请输入天然气费" }],
        heatingCost: [{ required: true, message: "请输入暖气费" }],
        propertyFee: [{ required: true, message: "请输入物业费" }],
        internetFee: [{ required: true, message: "请输入网费" }],
        serviceFee: [{ required: true, message: "请输入服务费" }],
        fileList: [{ required: true, message: "请上传图片", trigger: "blur" }]
      },
      fangNum: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
      roomDirectionList: [
        "东",
        "南",
        "西",
        "北",
        "东南",
        "东北",
        "西南",
        "西北",
        "南北通透"
      ],
      shortRentList: [
        { id: 0, name: "长租" },
        { id: 1, name: "短租" }
      ],
      tempPartList: []
    };
  },
  created() {
    this.roomParts = cloneDeep(this.baseInfo.roomParts);
  },
  methods: {
    submit() {
      let flag = false;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.formData.fileList.length == 0) {
            flag = false;
          } else {
            let urls = "";
            for (let item of this.formData.fileList) {
              urls += item.url + ",";
            }
            this.formData.images = urls.substring(0, urls.length - 1);
            flag = true;
          }
        } else {
          flag = false;
        }
      });
      return flag;
    },
    deleteItem() {
      this.$emit("deleteItem", this.refKey);
    },
    handleRemove(file) {
      const index = this.formData.fileList.indexOf(file);
      const newFileList = this.formData.fileList.slice();
      newFileList.splice(index, 1);
      this.formData.fileList = newFileList;
    },
    beforeUpload(file) {
      //压缩图片
      new ImageCompressor(file, {
        quality: 0.6,
        success: res => {
          this.uploadImage(res);
        },
        error: err => {
          this.$message.error("图片压缩失败");
        }
      });
      return false;
    },
    uploadImage(file) {
      let server = this.oss.service;
      let OSSAccessKeyId = this.oss.key;
      let AccessKeySecret = this.oss.secret;
      let floder = this.oss.floder;

      let policyText = {
        expiration: this.oss.validTime, //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
        conditions: [
          ["content-length-range", 0, 20971520] // 设置上传文件的大小限制 20mb
        ]
      };
      let policyBase64 = base64.encode(JSON.stringify(policyText));
      let message = policyBase64;
      let bytes = hmac.HMAC(message, AccessKeySecret, {
        asBytes: true
      });
      let signature = crypto.bytesToBase64(bytes);

      let position = file.name.lastIndexOf(".");
      let suffix =
        position == -1
          ? ".png"
          : file.name.substring(position, file.name.length);

      //文件名
      let fileName = "house_" + new Date().getTime() + suffix;
      //文件路径
      let fileUrl = server + floder + fileName;
      let data = new FormData();
      data.append("key", floder + fileName);
      data.append("policy", policyBase64);
      data.append("OSSAccessKeyId", OSSAccessKeyId);
      data.append("success_action_status", "200");
      data.append("signature", signature);
      data.append("file", file);

      request
        .upload("/api/oss/", data)
        .then(res => {
          const item = {};
          item.name = fileName;
          item.url = fileUrl;
          if (!this.formData.smallImage) {
            this.formData.smallImage = fileUrl;
          }
          item.uid = new Date().getTime();
          item.status = "done";
          this.formData.fileList.push(item);
        })
        .catch(err => {
          console.log(err);
        });
    },
    partHandleChange(tag, checked) {
      const selectKey = Object.assign([], this.tempPartList);
      const nextSelectedTags = checked
        ? [...selectKey, tag]
        : selectKey.filter(t => t !== tag);
      this.tempPartList = nextSelectedTags;
      this.formData.roomParts = this.tempPartList.join();
    }
  }
};
</script>

<style lang="less" scoped>
.form {
  margin-top: 20px;
}
/deep/ .ant-form-item-label {
  width: 105px !important;
}
</style>
